import HttpRequest from './http_request'

class AnnouncementProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT+'admission/api/')
  }
  async getTcasFaculty() {
    const { data } = await this.get('/', {
      function: 'get-tcas-faculty',
    })
    return data
  }
  async getTcasFacultyById(id) {
    const { data } = await this.get('/', {
      function: 'get-tcas-faculty',
      select: ["faculty_id", "faculty_name", "faculty_ename"],
      where: [{faculty_id: id}]
    })
    return data
  }
///////////////////////////////////////ระดับปริญญาตรี
//NewsMain
  async getNewsMains() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '0',
    })
    return data
  }
//-------------------------------------------------------------International Program 
//ประกาศรับสมัคร
  async getNewsInters_application() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '51',
    })
    return data
  }
//ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ
  async getNewsInters_writing() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '53',
    })
    return data
  }
//ผู้มีสิทธิ์สอบสัมภาษณ์
  async getNewsInters_interview() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '54',
    })
    return data
  }
//ผู้มีสิทธิ์เคลียริงเฮาส์
  async getNewsInters_clearing() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '8',
      inter: '1',
    })
    return data
  }
//ผู้มีสิทธิ์เข้าศึกษา
  async getNewsInters_qualified() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '55',
    })
    return data
  }
//ผู้ยืนยันสิทธิ์
  async getNewsInters_confirm() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '56',
    })
    return data
  }
//-------------------------------------------------------------หลักสูตรต่อเนื่อง 
//ประกาศรับสมัคร
  async getNewsCons_application() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '31',
    })
    return data
  }
//ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ
  async getNewsCons_writing() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '33',
    })
    return data
  }
//ผู้มีสิทธิ์สอบสัมภาษณ์
  async getNewsCons_interview() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '34',
    })
    return data
  }
//ผู้มีสิทธิ์เคลียริงเฮาส์
  async getNewsCons_clearing() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '38',
    })
    return data
  }
//ผู้มีสิทธิ์เข้าศึกษา
  async getNewsCons_qualified() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '35',
    })
    return data
  }
//ผู้ยืนยันสิทธิ์
  async getNewsCons_confirm() {
    const { data } = await this.get('/', {
      function: 'get-tcas-news',
      group_id: '36',
    })
    return data
  }
//-------------------------------------------------------------หลักสูตรอาชีวะพรีเมียม 
//ประกาศรับสมัคร
async getNewsPremiums_application() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '21',
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ
async getNewsPremiums_writing() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '23',
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsPremiums_interview() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '24',
  })
  return data
}
//ผู้มีสิทธิ์เคลียริงเฮาส์
async getNewsPremiums_clearing() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '28',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsPremiums_qualified() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '25',
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsPremiums_confirm() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '26',
  })
  return data
}
//-------------------------------------------------------------หลักสูตร TCAS
//ประกาศรับสมัคร
async getNewsTCASs_application({round}) {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '1',
    round: round,
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ
async getNewsTCASs_writing({round}) {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '3',
    round: round,
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsTCASs_interview({round}) {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '4',
    round: round,
  })
  return data
}
//ผู้มีสิทธิ์เคลียริงเฮาส์
async getNewsTCASs_clearing({round}) {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '8',
    round: round,
    inter: '0',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsTCASs_qualified({round}) {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '5',
    round: round,
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsTCASs_confirm({round}) {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '6',
    round: round,
  })
  return data
}
//-------------------------------------------------------------รอบพิเศษ
//ประกาศรับสมัคร
async getNewsSpecials_application() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '41',
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ
async getNewsSpecials_writing() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '43',
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsSpecials_interview() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '44',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsSpecials_qualified() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '45',
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsSpecials_confirm() {
  const { data } = await this.get('/', {
    function: 'get-tcas-news',
    group_id: '46',
  })
  return data
}


///////////////////////////////////////ระดับบัณฑิตศึกษา
//NewsMain //ข่าวประชาสัมพันธ์
async getNewsGraduateMains() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '3',
  })
  return data
}
//-------------------------------------------------------------Pdf file for graduate
//pdf ประกาศรับสมัครของบัณฑิต
async getNewsGraduate_annoucement_pdf_files() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '2',
  })
  return data
}
//-------------------------------------------------------------หลักสูตรปริญญาโท
//ประกาศรับสมัคร
async getNewsMasters_annoucement() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '1',
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน
async getNewsMasters_writing() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '4',
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsMasters_interview() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '5',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsMasters_qualified() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '6',
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsMasters_confirm() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '2',
    group_id: '7',
  })
  return data
}
//-------------------------------------------------------------หลักสูตรปริญญาเอก
//ประกาศรับสมัคร
async getNewsDoctors_annoucement() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '3',
    group_id: '1',
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน
async getNewsDoctors_writing() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '3',
    group_id: '4',
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsDoctors_interview() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '3',
    group_id: '5',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsDoctors_qualified() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '3',
    group_id: '6',
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsDoctors_confirm() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '3',
    group_id: '7',
  })
  return data
}
//-------------------------------------------------------------หลักสูตรโครงการ 4+1
//ประกาศรับสมัคร
async getNewsFutureInnovators_annoucement() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '4',
    group_id: '1',
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน
async getNewsFutureInnovators_writing() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '4',
    group_id: '4',
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsFutureInnovators_interview() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '4',
    group_id: '5',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsFutureInnovators_qualified() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '4',
    group_id: '6',
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsFutureInnovators_confirm() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '4',
    group_id: '7',
  })
  return data
}
//-------------------------------------------------------------หลักสูตรนานาชาติ
//ประกาศรับสมัคร
async getNewsGraduateInters_annoucement() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '5',
    group_id: '1',
  })
  return data
}
//ผู้มีสิทธิ์สอบข้อเขียน
async getNewsGraduateInters_writing() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '5',
    group_id: '4',
  })
  return data
}
//ผู้มีสิทธิ์สอบสัมภาษณ์
async getNewsGraduateInters_interview() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '5',
    group_id: '5',
  })
  return data
}
//ผู้มีสิทธิ์เข้าศึกษา
async getNewsGraduateInters_qualified() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '5',
    group_id: '6',
  })
  return data
}
//ผู้ยืนยันสิทธิ์
async getNewsGraduateInters_confirm() {
  const { data } = await this.get('/', {
    function: 'get-entrance-x-news',
    level: '5',
    group_id: '7',
  })
  return data
}

}

export default AnnouncementProvider